
import '../main/js/tweenmax.js';
import dndPromotion from '../main/js/promotion2.js';
import './scss/block_2.scss';

window.addEventListener("load", function () {
  dndPromotion({
    //url: domain,   
    debug: prodTemplate.debug,
    url: prodTemplate.url,
    directory: prodTemplate.directory,
    items: prodTemplate.items,
    names: prodTemplate.names,
    config: {
      // countStart: 99,
      // countEnd: 0,
      // start: true,
      // end: false,
      classImg: ".effect__item",
      timeWait: 3000,
      animationCircle: false,
      statusCustom: false
    },
    animResult: function (listPrize) {
      $('.promotion .chuong').addClass('active');
    },
    callback: function () {
      $('.promotion .chuong').removeClass('active');

    },
  });
});